<script>
    import { Row, Col } from 'sveltestrap'
    import { Select, InputColorPicker } from '@fno/component2/form.js'
    import FormAlerts from '../FormAlerts.svelte'
    import FormSavingButtons from '../FormSavingButtons.svelte'

    import HomePreview from './previews/home/home-preview.svelte'
    import EventPreview from './previews/event-info/event-preview.svelte'
    import SchedulePreview from './previews/schedule/schedule-preview.svelte'
    import TeamPreview from './previews/team-info/team-info-preview.svelte'

    export let context
    export let saving

    let primaryColor
    let secondaryColor

    $: primaryColor = context.form.appColors.attributes.primary
    $: secondaryColor = context.form.appColors.attributes.secondary

    const themeOptions = [
        {
            id: false,
            name: 'Light Theme'
        },
        {
            id: true,
            name: 'Dark Theme'
        }
    ]

    let scrollY
    let affix

    $: {
        if (affix) {
            if (scrollY > 214) {
                affix.style.top = '0'
                affix.style.left = `${affix.offsetLeft}px`
                affix.style.position = 'sticky'
            } else {
                affix.style.position = 'inherit'
                affix.style.top = 'inherit'
                affix.style.left = 'inherit'
            }
        }
    }
</script>

<style>
    .fno-color-pickers :global(.component-form-field-color) {
        margin: 25px 0;
    }
</style>

<svelte:window bind:scrollY />

<h1>Design Your App</h1>

<p>
    The following screens are an example of how the theme is applied in your app. To change out a color on your app,
    click on one of the two main colors used below. Choose your new color with the color picker, and the screens will
    change to that color accordingly. If you need to change one of your main colors, use the previous step button to go
    back and edit your color information.
</p>

<Row class="mt-5">
    <Col xs="12" md="12" lg="4" xl="4">
        <div bind:this={affix}>
            <Select
                label="Dark or Light Theme"
                {context}
                options={themeOptions}
                formKey="appColors"
                keypath="attributes.dark"
                bind:value={context.form.appColors.attributes.dark}
                on:change
            />

            <div class="fno-color-pickers d-flex flex-column align-items-center">
                <InputColorPicker
                    {context}
                    required
                    label="Primary Color (Hex #)"
                    formKey="appColors"
                    keypath="attributes.primary"
                    on:change
                    bind:value={context.form.appColors.attributes.primary}
                />

                <InputColorPicker
                    {context}
                    required
                    label="Secondary Color (Hex #)"
                    formKey="appColors"
                    keypath="attributes.secondary"
                    on:change
                    bind:value={context.form.appColors.attributes.secondary}
                />
            </div>
        </div>
    </Col>
    <Col xs="12" md="12" lg="8" xl="8" class="d-flex flex-column align-items-center">
        <p class="w-50 text-center">
            Below is a preview of what your app could look like. Final theme approval happens with your Customer Success
            Coach during the client review process.
        </p>

        <div class="fno-tinted-screenshots">
            <!-- SCREEN ONE: HOME -->
            <HomePreview
                theme={context.form.appColors.attributes.dark}
                primary={`#${primaryColor}`}
                secondary={`#${secondaryColor}`}
            />

            <!-- SCREEN TWO: EVENT -->
            <EventPreview
                theme={context.form.appColors.attributes.dark}
                primary={`#${primaryColor}`}
                secondary={`#${secondaryColor}`}
            />

            <!-- SCREEN THREE: SCHEDULE -->
            <SchedulePreview
                theme={context.form.appColors.attributes.dark}
                primary={`#${primaryColor}`}
                secondary={`#${secondaryColor}`}
            />

            <!-- SCREEN FOUR: TEAM  -->
            <TeamPreview
                theme={context.form.appColors.attributes.dark}
                primary={`#${primaryColor}`}
                secondary={`#${secondaryColor}`}
            />
        </div>
    </Col>
</Row>

<FormAlerts bind:alerts={context.alerts} />

<FormSavingButtons {context} {saving} on:save on:nextStepClicked on:previousStepClicked />
